"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var filterObject = function filterObject() {
	var unfiltered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var allowed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	return Object.keys(unfiltered).filter(function (key) {
		return allowed.includes(key);
	}).reduce(function (filtered, key) {
		filtered[key] = unfiltered[key]; // eslint-disable-line no-param-reassign
		return filtered;
	}, {});
};

exports.default = filterObject;


// WEBPACK FOOTER //
// ./~/@workmarket/js-utils/dist/filterObject/index.js